import React from 'react';
import './CustomCheckbox.scss';

const CustomCheckbox = ({ label, checked, onChange, id }) => {
    return (
        <label className="custom-checkbox">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                id={id}
            />
            <span className="checkbox-mark"></span>
            {label && <span className="checkbox-label">{label}</span>}
        </label>
    );
};

export default CustomCheckbox;
